import { alpha } from "@mui/material";
import { makeStyles } from "tss-react/mui";

export const AdvFilterStyles = makeStyles()(
    (theme, p, classes) => ({

        popperRoot: {
            zIndex: theme.zIndex.drawer + 1,
            borderWidth: 1,
            borderStyle: "solid",
            borderColor: theme.palette.grey[700],
            maxHeight: 300,
            overflowY: "auto"
        },

        popperRootOverModal: {
            zIndex: theme.zIndex.modal + 1,
        },

        popList: {
            paddingTop: 4,
            paddingBottom: 4,
            fontSize: ".85rem",
            lineHeight: "auto",
            height: "auto",
            minHeight: "unset"
        },

        autocompleteInputRoot: {
            flexWrap: "wrap",
            "& input": {
                width: "1px",
                flexGrow: 1
            }
        },
        autocompleteChip: {
            margin: parseInt(theme.spacing()) / 2,
            "& img": {
                objectFit: "scale-down"
            }
        },

        autocompleteLimitedWidth: {
            maxWidth: "200px",
            overflow: "hidden",
            textOverflow: "ellipsis",
            display: "block"
        },

        root: {
            flexGrow: 1,
        },

        container: {
            position: 'relative',
        },

        paper: {
            position: 'absolute',
            zIndex: 1,
            marginTop: theme.spacing(),
            left: 0,
            right: 0,
        },


        divider: {
            height: theme.spacing(2),
        },

        loadMore: {
            fontSize: theme.typography.caption.fontSize,
            color: theme.typography.caption.color
        },

        inputRoot: {
            color: 'inherit',
            width: '100%',
            flexWrap: 'wrap',
        },

        inputInput: {
            display: "block"
        },

        inputUnderline: {
            "&:after": {
                borderBottom: "1px solid inherit"
            }
        },

        inputUnderlineWhite: {
            "&:after": {
                borderBottom: "1px solid " + theme.palette.common.white
            }
        },
        inputUnderlineBlack: {
            "&:after": {
                borderBottom: "1px solid " + theme.palette.common.black
            }
        },

        inputUnderlineMuted: {
            "&:after": {
                borderBottom: "1px solid " + theme.palette.muted.dark
            }
        }
    })
);

export const GenericListsStyles = makeStyles()(
    (theme, p, classes) => ({
        root: {
            width: '100%',
        },

        table: {
            "& img": {
                width: 24,
                height: 24
            },
            "& td:nth-child(3)": {
                paddingLeft: "8px",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                maxWidth: 0
            }
        },

        tableContainer: {
            height: "400px",
            overflow: 'auto',
        },

        inputRoot: {
            color: 'inherit',
            width: '100%',
        },
        inputInput: {
            paddingTop: theme.spacing(),
            paddingRight: theme.spacing(),
            paddingBottom: theme.spacing(),
            paddingLeft: theme.spacing(6),
            transition: theme.transitions.create('width'),
            width: '100%'
        },

        search: {
            position: 'relative',
            borderRadius: theme.shape.borderRadius,
            backgroundColor: alpha(theme.palette.grey[500], 0.15),
            '&:hover': {
                backgroundColor: alpha(theme.palette.grey[500], 0.25),
            },
            marginBottom: theme.spacing(),
            width: '100%',
            [theme.breakpoints.up('sm')]: {
                width: 'auto',
            },
        },
        searchIcon: {
            width: theme.spacing(5),
            height: '100%',
            position: 'absolute',
            pointerEvents: 'none',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
        },
    })
);
